import React, { useState } from 'react';

/** Indica se a etapa pode exibir o bloco de respostas (permissão + dados da API). */
export function performanceReportStepResponsesAvailable(
    step,
    itemCommentsAllowed,
    assessmentType
) {
    const restricted =
        (assessmentType === 'SD' || assessmentType === 'TD') &&
        itemCommentsAllowed === false;
    if (restricted) {
        return false;
    }
    return step.step_item_sessions !== null;
}

/**
 * Linhas extras abaixo de cada etapa: respostas por item (título, nota, comentário).
 * useExternalToggle: esconde a linha "Ver respostas"; controle expanded no pai (ex.: ícone na coluna Etapa).
 */
export default function PerformanceReportStepCommentsRows({
    step,
    itemCommentsAllowed,
    assessmentType,
    useExternalToggle = false,
    expanded: expandedProp,
    onExpandedChange,
}) {
    const [internalOpen, setInternalOpen] = useState(false);
    const restricted =
        (assessmentType === 'SD' || assessmentType === 'TD') &&
        itemCommentsAllowed === false;
    if (restricted) {
        return null;
    }
    const sessions = step.step_item_sessions;
    if (sessions === null) {
        return null;
    }

    const open = useExternalToggle ? Boolean(expandedProp) : internalOpen;
    const setOpen = (next) => {
        if (useExternalToggle) {
            onExpandedChange?.(typeof next === 'function' ? next(open) : next);
        } else {
            setInternalOpen(typeof next === 'function' ? next(internalOpen) : next);
        }
    };

    const hasItems = sessions.some((s) => s.items && s.items.length > 0);

    return (
        <>
            {!useExternalToggle ? (
                <tr className="align-middle">
                    <td />
                    <td colSpan={5} className=" pt-1 border-top-0">
                        <span
                            className="text-default text-decoration-none cursorPointer pb-2"
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    setOpen((v) => !v);
                                }
                            }}
                            onClick={() => setOpen((v) => !v)}
                        >
                            Ver respostas
                        </span>
                    </td>
                </tr>
            ) : null}
            {open ? (
                <tr className="table-light">
                    <td />
                    <td colSpan={5} className="small border-top-0">
                        {!hasItems ? (
                            <p className="text-muted mb-0 py-1">
                                Nenhuma resposta registrada nesta etapa.
                            </p>
                        ) : (
                            <div className="py-2">
                                {sessions.map((sess) => (
                                    <div key={sess.session_id} className="mb-1">
                                        <div className="fw-semibold text-green">
                                            {sess.session_title}
                                        </div>
                                        <ul className="list-unstyled mb-0 ms-2 mt-1">
                                            {sess.items.map((it) => {
                                                const notaText =
                                                    it.rating_label !== null &&
                                                    it.rating_label !== ''
                                                        ? it.rating_score !== null &&
                                                          it.rating_score !== ''
                                                            ? `${it.rating_label} (${it.rating_score}/5)`
                                                            : it.rating_label
                                                        : null;
                                                return (
                                                    <li
                                                        key={`${sess.session_id}-${it.item_kind}-${it.item_id}`}
                                                        className="mb-1 border-bottom border p-2 pb-0 rounded"
                                                    >
                                                        <div
                                                            className="text-muted text-uppercase"
                                                            style={{
                                                                fontSize: '0.7rem',
                                                                letterSpacing: '0.02em',
                                                            }} dangerouslySetInnerHTML={{ __html: it.item_title || '—' }}
                                                        />
                                                        <div className="mt-1">
                                                            <span className="text-muted">Nota: </span>
                                                            {notaText || '—'}
                                                        </div>
                                                        <div className="mt-1">
                                                            <span className="text-muted">
                                                                Comentário:{' '}
                                                            </span>
                                                            {it.comment ? (
                                                                <span
                                                                    className="text-body"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: it.comment,
                                                                    }}
                                                                />
                                                            ) : (
                                                                <span className="text-muted fst-italic">
                                                                    Sem comentário
                                                                </span>
                                                            )}
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        )}
                    </td>
                </tr>
            ) : null}
        </>
    );
}
